import React from 'react';
import SurveyIcon from '../../survey/SurveyIcon';
import Icon from '../../common/Icon.react';

const FilePreview = ({ blob, mimeType, preview, url }) => {
  if (!mimeType) {
    return <span />;
  }
  try {
    if (mimeType.match(/image/)) {
      const src = url || preview || window.URL.createObjectURL(blob);
      return <img src={src} style={{ maxWidth: '100%' }} alt="" />;
    } else if (mimeType.match(/video/)) {
      return preview ? (
        <video src={preview} style={{ maxWidth: '100%' }} />
      ) : null;
    } else {
      return <SurveyIcon icon="file" />;
    }
  } catch (exception) {
    console && console.warn && console.warn(exception);
    return <span />;
  }
};

export default function FilePreviewWrapper(props) {
  return (
    <div
      className="attachment attachment--image pos-r"
      style={{ maxWidth: '100%' }}
    >
      <FilePreview {...props} />
      <div className="d-flex jc-center align-center pos-a pos-cover bc-white-50">
        <div>
          <Icon icon="ajax" />
        </div>
      </div>
    </div>
  );
}
